import React from 'react'

export const LessonContext = React.createContext({ mode: 'edit' })
